import { Tool } from "@/types/tools";
import LineChartOutlined from "@ant-design/icons/es/icons/LineChartOutlined";
import { ClimateMetricsTool } from "./ClimateMetricsTool";
export default {
  id: "climate-metrics",
  category: "dataVisualisation",
  keyPrefix: "dataVisualisation.climateMetrics",
  icon: <LineChartOutlined />,
  maxWidth: "1400px",
  render: () => <ClimateMetricsTool />
} as Tool;